<!-- eslint-disable vue/multi-word-component-names -->
<script>
  export default {
    props: {
      headers: {
        type: Array,
        default: () => [],
      },
      hasGroupByOption: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
<template>
  <thead>
    <tr>
      <th v-for="(header, index) in headers" :key="index" :style="header?.style">
        <div class="flex-gap-1 justify-center">
          <span class="text-center">{{ header.text }}</span>
          <v-btn
            v-if="header?.isSortable"
            @click="sortStatus(header)"
            @click.stop="$emit('sort', header.value)"
            icon
          >
            <v-icon v-if="header?.sortState == 1">mdi-arrow-up mdi-18px</v-icon>
            <v-icon v-if="header?.sortState == 2">mdi-arrow-down mdi-18px</v-icon>
          </v-btn>
          <v-btn
            v-if="header?.isGroupable || hasGroupByOption"
            @click.stop="$emit('group', header.value)"
            icon
          >
            <v-icon>mdi-flip-to-back mdi-18px</v-icon>
          </v-btn>
        </div>
      </th>
    </tr>
  </thead>
</template>
